/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { ShortDisclosure } from '../models/short-disclosure';
import { ShortDisclosureFilter } from '../models/short-disclosure-filter';
@Injectable({
  providedIn: 'root',
})
class ShortDisclosureService extends __BaseService {
  static readonly getShortDisclosurePath = '/shortDisclosure';
  static readonly updateShortDisclosurePath = '/shortDisclosure/update/';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param sdFilter undefined
   * @return A list of short disclosures
   */
  getShortDisclosureResponse(sdFilter: ShortDisclosureFilter): __Observable<__StrictHttpResponse<Array<ShortDisclosure>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = sdFilter;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/shortDisclosure`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<ShortDisclosure>>;
      })
    );
  }
  /**
   * @param sdFilter undefined
   * @return A list of short disclosures
   */
  getShortDisclosure(sdFilter: ShortDisclosureFilter): __Observable<Array<ShortDisclosure>> {
    return this.getShortDisclosureResponse(sdFilter).pipe(
      __map(_r => _r.body as Array<ShortDisclosure>)
    );
  }

  /**
   * @param shortDisclosure undefined
   * @return A Updated short disclosures
   */
  updateShortDisclosureResponse(shortDisclosure: ShortDisclosure): __Observable<__StrictHttpResponse<ShortDisclosure>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = shortDisclosure;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/shortDisclosure/update/`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ShortDisclosure>;
      })
    );
  }
  /**
   * @param shortDisclosure undefined
   * @return A Updated short disclosures
   */
  updateShortDisclosure(shortDisclosure: ShortDisclosure): __Observable<ShortDisclosure> {
    return this.updateShortDisclosureResponse(shortDisclosure).pipe(
      __map(_r => _r.body as ShortDisclosure)
    );
  }
}

module ShortDisclosureService {
}

export { ShortDisclosureService }
